import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import "../Tabla.css";
import DialogoConfirmacionPartes from "./DialogoConfirmacionPartes";
import ModalModificarPartes from "./ModalModificarPartes";

const TablaPartes = ({ datosTabla, origen }) => {
  const [itemClicked, setItemClicked] = useState(undefined);

  const columns = [
    {
      name: "nombre",
      label: "Nombre ",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (value, tableMeta, updateValue) => (
          <DialogoConfirmacionPartes id={datosTabla[value][1]} />
        ),
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,
    responsive: "standard",
    searchPlaceholder: "Buscar ",
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    rowsPerPage: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    download: false,
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.name}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
      },

      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Esconder columnas",
      },

      TableHead: {
        root: {
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />
      {itemClicked && (
        <ModalModificarPartes
          onHide={handleDeleteItemClicked}
          nombre={itemClicked[0]}
          id={itemClicked[1]}
        />
      )}
    </div>
  );
};

export default TablaPartes;
